// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCardInfoModel {
    static getAttributeTypeMap() {
        return EnrollmentCardInfoModel.attributeTypeMap;
    }
}
EnrollmentCardInfoModel.discriminator = undefined;
EnrollmentCardInfoModel.additionalProperties = false;
EnrollmentCardInfoModel.attributeTypeMap = [
    {
        "name": "cardLastFourDigits",
        "baseName": "cardLastFourDigits",
        "type": "string"
    },
    {
        "name": "expirationDate",
        "baseName": "expirationDate",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentCardInfoModel.js.map